import styles from "../DownloadVideo/DownloadVideo.module.scss";
import contest_arrow from "../../../../assets/img/contest_arrow.svg";
import {useNavigate} from "react-router-dom";
import TextField from "@mui/material/TextField";
import React, {useState} from "react";
import FormControl from "@mui/material/FormControl";
import {useDispatch, useSelector} from "react-redux";
import {sendEventData} from "../../NewYearEvent/eventSlice";
import Loader from "../../../subsidiary/Loader/Loader";
import GoBack from "../../../subsidiary/GoBack/GoBack";

const DownloadVideo = () => {
    const contestId = localStorage.getItem('contestID')
    const purposeId = localStorage.getItem('chosenPurposeID')
    const navigate = useNavigate()
    const [file, setFile] = useState()
    const token = useSelector(state => state.loginSlice.token)
    const dispatch = useDispatch()
    const [videoLoading, setVideoLoading] = useState(false)
    const fileChange = (e) => {
        setFile(e.target.files[0])
        const maxSize = 300 * 1024 * 1024;
        if (file && file.size > maxSize) {
            window.showAlert({ title: 'Файл слишком большой. Максимальный размер: 300 МБ', type: 'error' })
            e.target.value = '';
            return;
        }
    }

    const sendImage = () => {
        setVideoLoading(true)
        let formData = new FormData()
        formData.append('media', file)
        formData.append('type', 'video');
        console.log(formData)
        dispatch(sendEventData({token, formData, contestID: contestId}))
            .then((params) => {
                if (params.error) {
                    window.showAlert({title: 'Что то пошло не так', type: 'error'})
                } else {
                    window.showAlert({title: 'Видео успешно загружено', type: 'success'})
                    navigate(`/success`)
                }
            })

    }

    return (
        <section className='main'>
            {videoLoading ? <Loader/> :
            <div className='content-wrapper'>
                <GoBack text='Назад'/>
                <h2 className={styles.videoHeading}>Загрузить видео</h2>
                <input className={styles.videoInput} placeholder={"Название видео"}/>
                <FormControl className={styles.videoInput}>
                    <input required className={styles.videoInput} onChange={e => fileChange(e)} id='file'
                           type='file'
                           accept="video/*"
                           style={{display: "none"}}
                           placeholder='Загрузить видео' variant="outlined"/>
                    <input style={{margin: 0}} className={styles.videoInput} type='text'
                           onClick={() => document.getElementById('file').click()}
                           value={file ? `Приложeно: ${file.name}` : ''}
                           placeholder='Приложить видео' variant="outlined"/>
                    <label htmlFor="file">
                        <div className='plus_icon-container'>
                                <span onClick={() => file ? setFile(null) : ''}
                                      className={file ? 'icon_active' : 'plus_icon'}>+</span>
                        </div>
                    </label>
                </FormControl>

                <div onClick={file ? sendImage : null} className={styles.successContainer}>
                    {file
                        ? <button
                            disabled={videoLoading}
                            className={styles.successBtn}
                        >
                            Участвовать
                        </button>
                        : ''
                    }
                </div>
            </div>
            }
        </section>
    )
}

export {DownloadVideo}
